import { useMutation, useQueryClient } from 'react-query';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { removeRosterQualifications } from 'RestAPIs/qualifications';

type RemoveRosterQualificationsVariables = {
  costCenterId: number;
  qualificationId: string;
};

const useRemoveRosterQualifications = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, RemoveRosterQualificationsVariables>(
    ({ costCenterId, qualificationId }) =>
      removeRosterQualifications(costCenterId, qualificationId),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries([
          'rosterQualifications',
          'list',
          variables.costCenterId
        ]);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useRemoveRosterQualifications;
